import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-elements';

const HeaderOverlay = ({ onClose }: any) => {
  return (
    <View style={styles.topOverlay}>
      <View style={styles.closeButtonContainer}>
        <TouchableOpacity onPress={onClose}>
          <Icon
            tvParallaxProperties={null}
            activeOpacity={0.5}
            name={'close'}
            size={30}
            color={'#505050'}
            style={styles.closeButtonImage}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  closeButtonContainer: {
    height: '100%',
    zIndex: 1000,
    flex: 1,
    alignContent: 'center',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginStart: 10,
  },
  closeButtonImage: {},
  topOverlay: {
    opacity: 0.5,
    borderTopStartRadius: 10,
    borderTopEndRadius: 10,
    overflow: 'hidden',
    height: 40,
    fontWeight: 'bold',
    zIndex: 1001,
    backgroundColor: '#ffffff',
    padding: 0,
    marginTop: 0,
    position: 'absolute',
    width: '100%',
    top: 0,
  },
});

export default HeaderOverlay;
